import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Newsletter Section */}
        <div className="newsletter-section">
          <h3>Subscribe to My Newsletter</h3>
          <p>Stay updated with my latest books, speaking events, and wellness insights delivered straight to your inbox.</p>
          <div className="newsletter-form">
            <input type="email" placeholder="Enter your email address" className="newsletter-input" />
            <button className="newsletter-btn">Subscribe Now</button>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-column">
            <div className="footer-brand">
              <div className="footer-logo">
                <img src="/assets/logo2.png" alt="Francis Odame Writes" className="footer-logo-image" />
                <span className="brand-name">Francis Odame Writes</span>
              </div>
              <p className="footer-description">
                Empowering the next generation through powerful storytelling, wellness advocacy, and community outreach.
              </p>
              <div className="social-icons">
                    <a href="mailto:info@francisodame.com" className="social-icon" title="Email">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </a>
                    <a href="https://www.facebook.com/share/1AS7TuWt2U/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="social-icon" title="Facebook">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </a>
                    <a href="https://www.instagram.com/fodamewrites?igsh=MWF5OHQ4eDlzeHZ2aw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="social-icon" title="Instagram">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" strokeWidth="2"/>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z" stroke="currentColor" strokeWidth="2"/>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </a>
                    <a href="https://www.linkedin.com/in/francis-odame-2833a7216?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer" className="social-icon" title="LinkedIn">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M16 8C18.2091 8 20 9.79086 20 12V21H16V12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12V21H10V8H14V9.5C14.5523 9.5 15 9.05228 15 8.5C15 7.94772 14.5523 7.5 14 7.5H10C8.89543 7.5 8 8.39543 8 9.5V21H4V8H8V9.5C8.55228 9.5 9 9.05228 9 8.5C9 7.94772 8.55228 7.5 8 7.5H4C2.89543 7.5 2 8.39543 2 9.5V21C2 22.1046 2.89543 23 4 23H20C21.1046 23 22 22.1046 22 21V12C22 9.79086 20.2091 8 18 8H16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </a>
                    <a href="https://www.tiktok.com/@fodamewrites?_t=ZN-907HCZMxm6w&_r=1" target="_blank" rel="noopener noreferrer" className="social-icon" title="TikTok">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </a>
              </div>
            </div>
          </div>

          <div className="footer-column">
            <h4>Latest Books</h4>
            <div className="footer-links">
              <Link to="/books" className="footer-link">Because of Abigail</Link>
              <Link to="/books" className="footer-link">Waterstones</Link>
              <Link to="/books" className="footer-link">Hatchards</Link>
              <Link to="/books" className="footer-link">Google Books</Link>
            </div>
          </div>

          <div className="footer-column">
            <h4>Pages</h4>
            <div className="footer-links">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/about" className="footer-link">About</Link>
              <Link to="/books" className="footer-link">Books</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </div>
          </div>

          <div className="footer-column">
            <h4>Legal</h4>
            <div className="footer-links">
              <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
              <Link to="/cookie-policy" className="footer-link">Cookie Policy</Link>
              <Link to="/refund-policy" className="footer-link">Refund Policy</Link>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">&copy; 2024 Francis Odame Writes. All rights reserved. Designed by Iksoft Technologies.</p>
            <div className="footer-bottom-links">
              <Link to="/privacy-policy" className="bottom-link">Privacy Policy</Link>
              <Link to="/terms-of-service" className="bottom-link">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
